import React, { useMemo } from 'react';
import { arrayOf, func, object, shape, string } from 'prop-types';
import Tile from './tile';
import { useStyle } from '@magento/venia-ui/lib/classify'; //'../../classify';

import defaultClasses from './tileList.module.css';

var TileList = function TileList(props) {
  var getItemKey = props.getItemKey,
      _props$selectedValue = props.selectedValue,
      selectedValue = _props$selectedValue === void 0 ? {} : _props$selectedValue,
      items = props.items,
      onSelectionChange = props.onSelectionChange;
  var classes = useStyle(defaultClasses, props.classes); // console.log(selectedValue);

  var tiles = useMemo(function () {
    return items.map(function (item) {
      var isSelected = item.label === selectedValue.label;
      return React.createElement(Tile, {
        key: getItemKey(item),
        isSelected: isSelected,
        item: item,
        onClick: onSelectionChange
      });
    });
  }, [getItemKey, selectedValue.label, items, onSelectionChange]);
  return React.createElement("div", {
    className: classes.root
  }, tiles);
};

TileList.propTypes = {
  classes: shape({
    root: string
  }),
  getItemKey: func,
  selectedValue: object,
  items: arrayOf(object),
  onSelectionChange: func
};
TileList.displayName = 'TileList';
export default TileList;